import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface UpdateCartItemMutationObject {
  mutation: {
    updateCartItems: {
      __args: {
        input: {
          cart_id: string
          cart_items: [
            {
              cart_item_id: number
              quantity: number
              [key: string]: any
            }
          ]
          [key: string]: any
        }
      }
      [key: string]: any
    }
  }
}

export const updateCartItemMutationObject: UpdateCartItemMutationObject = {
  mutation: {
    updateCartItems: {
      __args: {
        input: {
          cart_id: '',
          cart_items: [
            {
              cart_item_id: 0,
              quantity: 0
            }
          ]
        }
      }
    }
  }
}

interface UpdateCartItemsInput {
  cartId: string
  cartItemId: string
  quantity: string
}

export type UpdateCartItemMutation = (input: UpdateCartItemsInput) => Promise<FetchResult<any>>

export const createUpdateCartItemMutation = ({ getMutations, getQueries }: ServiceDependencies): UpdateCartItemMutation => async ({ cartId, cartItemId, quantity }) => {
  const queries = getQueries()
  const mutation = getMutations().updateCartItemMutation
  mutation.mutation.updateCartItems.__args.input.cart_id = cartId
  mutation.mutation.updateCartItems.__args.input.cart_items[0].quantity = parseInt(quantity)
  mutation.mutation.updateCartItems.__args.input.cart_items[0].cart_item_id = parseInt(cartItemId)
  mutation.mutation.updateCartItems = {
    ...mutation.mutation.updateCartItems,
    cart: {
      ...queries.cartQuery,
      ...queries.cartPrices,
      ...queries.shippingAddresses,
      ...queries.billingAddresses,
      ...queries.cartAppliedCoupon
    }
  }

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`,
    fetchPolicy: 'no-cache'
  })
}
